import { render, staticRenderFns } from "./RelationDetailTodos.vue?vue&type=template&id=20b85474"
import script from "./RelationDetailTodos.vue?vue&type=script&lang=ts"
export * from "./RelationDetailTodos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports